import { render, staticRenderFns } from "./qusetionnairepaper.vue?vue&type=template&id=5b2addd2&scoped=true"
import script from "./qusetionnairepaper.vue?vue&type=script&lang=js"
export * from "./qusetionnairepaper.vue?vue&type=script&lang=js"
import style0 from "./qusetionnairepaper.vue?vue&type=style&index=0&id=5b2addd2&prod&lang=less"
import style1 from "./qusetionnairepaper.vue?vue&type=style&index=1&id=5b2addd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2addd2",
  null
  
)

export default component.exports